import { lazy } from 'react';
import { createRouter, createRoute, AnyRoute } from '@tanstack/react-router';

import config from '@/config';
import { basepath } from '@/constants';

import { issueSearchSchema } from '@/views/issue/Issue.hooks';

import { rootRoute } from './Route';
import { NotFound } from '@/views/RootRoute';
import { Auth } from './auth/Auth';

// Lazy loaded routes
const LazyCallback = lazy(() => import('./Callback'));
const LazyIssue = lazy(() => import('@/views/issue/Issue'));
const LazyDrafts = lazy(() => import('@/views/drafts/Drafts'));

import { route as indexRoute } from './home/Home';
import { callbackSearchSchema } from './Callback.schema';

/* Routes declaration */

const callbackRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyCallback,
	validateSearch: callbackSearchSchema,
	path: 'callback',
});

const issueRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: AuthLazyIssue,
	validateSearch: issueSearchSchema,
	path: 'issues/$id',
});

function AuthLazyIssue() {
	return (
		<Auth>
			<LazyIssue />
		</Auth>
	);
}

const issueArticleRoute = createRoute({
	getParentRoute: () => issueRoute,
	component: AuthLazyIssue,
	validateSearch: issueSearchSchema,
	path: '$articleId',
});

const draftsRoute = createRoute({
	getParentRoute: () => rootRoute,
	component: LazyDrafts,
	path: 'drafts',
});

/* END of routes declaration */

const routes: Array<AnyRoute> = [
	indexRoute,
	callbackRoute,
	issueRoute,
	issueArticleRoute,
];

if (config?.app?.admin) {
	routes.push(draftsRoute);
}

const routeTree = rootRoute.addChildren(routes);

export const router = createRouter({
	routeTree,
	basepath,
	defaultNotFoundComponent: NotFound,
});
